var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hometest" }, [
    _vm.$store.state.webNavigator == "pc"
      ? _c("div", { staticClass: "homeBox" }, [
          _c(
            "div",
            {},
            [
              _c("TopNavigation"),
              _c("div", {}, [
                _c("div", { staticClass: "testBar" }, [
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "swiper-container banner home-top home-rol"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "swiper-wrapper" },
                          _vm._l(_vm.rolllist, function(item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "swiper-slide" },
                              [
                                _c("img", {
                                  staticClass: "home-top-img",
                                  attrs: { src: item, alt: "", title: "" }
                                })
                              ]
                            )
                          }),
                          0
                        ),
                        _c("div", { staticClass: "swiper-button-prev" }),
                        _c("div", { staticClass: "swiper-button-next" }),
                        _c("div", { staticClass: "swiper-pagination" })
                      ]
                    ),
                    _c("div", { staticClass: "shubiao flexCenter" }, [
                      _c("img", {
                        staticClass: "shubiao-icon",
                        attrs: { title: "", src: _vm.src1, alt: "" }
                      })
                    ])
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "testBar testButton" },
                  [_c("homeTame", { attrs: { loadType: _vm.loadType } })],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "testBar" },
                  [
                    _c("homeVideo", {
                      attrs: { loadType: _vm.loadType2 },
                      on: { playVideo: _vm.getvideo }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "testBar" },
                  [_c("homeShop", { attrs: { loadType: _vm.loadType3 } })],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "testBar" },
                  [
                    _c("homeDoctorvideo", {
                      attrs: { loadType: _vm.loadType4 },
                      on: { playVideo2: _vm.getvideo }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "testBar" },
                  [
                    _vm.$store.state.home.getDotor.length
                      ? _c("homeExpert", { attrs: { loadType: _vm.loadType5 } })
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "testBar" },
                  [_c("homeNews", { attrs: { loadType: _vm.loadType6 } })],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "testBar150" },
                  [_c("FooterNavigation")],
                  1
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            [
              _c("playVideo", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.playVideoType,
                    expression: "playVideoType"
                  }
                ],
                attrs: { videoPlay: _vm.videoPlay, videoTlt: _vm.videoTlt },
                on: { funcVideo: _vm.downvideo }
              })
            ],
            1
          )
        ])
      : _c("div", { staticClass: "phone-page" }, [
          _c("div", [_c("TopNavigation")], 1),
          _c("div", { staticClass: "page-content" }, [
            _c(
              "div",
              { staticClass: "swiper-container bannerPhone home-top" },
              [
                _c(
                  "div",
                  { staticClass: "swiper-wrapper" },
                  _vm._l(_vm.rolllistPhone, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "swiper-slide" },
                      [
                        _c("img", {
                          style: {
                            width: 100 + "%",
                            height: 800 * (100 / 750) + "vw"
                          },
                          attrs: { src: item, alt: "", title: "" }
                        })
                      ]
                    )
                  }),
                  0
                ),
                _c("div", {
                  staticClass: "swiper-pagination",
                  attrs: { id: "swiper-paginationHome" }
                })
              ]
            ),
            _c("div", { staticClass: "phone-homeMain" }, [
              _c(
                "div",
                [_c("homeTame", { attrs: { loadType: _vm.loadType } })],
                1
              ),
              _c(
                "div",
                [
                  _c("homeVideo", {
                    attrs: { loadType: _vm.loadType2 },
                    on: { playVideo: _vm.getvideo }
                  })
                ],
                1
              ),
              _c(
                "div",
                [_c("homeShop", { attrs: { loadType: _vm.loadType3 } })],
                1
              ),
              _c(
                "div",
                [
                  _c("homeDoctorvideo", {
                    attrs: { loadType: _vm.loadType4 },
                    on: { playVideo2: _vm.getvideo }
                  })
                ],
                1
              ),
              _c(
                "div",
                [
                  _vm.$store.state.home.getDotor.length
                    ? _c("homeExpert", { attrs: { loadType: _vm.loadType5 } })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                [_c("homeNews", { attrs: { loadType: _vm.loadType6 } })],
                1
              )
            ])
          ]),
          _c("div", [_c("FooterNavigation")], 1),
          _c(
            "div",
            [
              _c("playVideo", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.playVideoType,
                    expression: "playVideoType"
                  }
                ],
                attrs: { videoPlay: _vm.videoPlay, videoTlt: _vm.videoTlt },
                on: { funcVideo: _vm.downvideo }
              })
            ],
            1
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ede37fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ede37fe","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/hometest/hometest.vue
// module id = 990
// module chunks = 1